import { render, staticRenderFns } from "./coming_soon.vue?vue&type=template&id=0775d40a&scoped=true"
import script from "./coming_soon.vue?vue&type=script&lang=js"
export * from "./coming_soon.vue?vue&type=script&lang=js"
import style0 from "./coming_soon.vue?vue&type=style&index=0&id=0775d40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775d40a",
  null
  
)

export default component.exports